import d from './D.png'
import e from './E.png'
import g from './G.png'
import m from './M.png'
import n from './N.png'
import r from './R.png'
import s from './S.png'
import t from './T.png'
import h from './H.png'
import a from './A.png'
import p from './P.png'
import b from './B.png'
import c from './C.png'
import i from './I.png'
import k from './K.png'
import f from './F.png'
import l from './L.png'
import o from './O.png'
import q from './Q.png'
import u from './U.png'
import v from './V.png'
import w from './W.png'
import x from './X.png'
import y from './Y.png'

import d1 from './D1.png'
import e1 from './E1.png'
import g1 from './G1.png'
import m1 from './M1.png'
import n1 from './N1.png'
import r1 from './R1.png'
import s1 from './S1.png'
import t1 from './T1.png'
import h1 from './H1.png'
import a1 from './A1.png'
import p1 from './P1.png'
import b1 from './B1.png'
import c1 from './C1.png'
import i1 from './I1.png'
import k1 from './K1.png'
import f1 from './F1.png'
import l1 from './L1.png'
import o1 from './O1.png'
import q1 from './Q1.png'
import u1 from './U1.png'
import v1 from './V1.png'
import w1 from './W1.png'
import x1 from './X1.png'
import y1 from './Y1.png'

import d2 from './D2.png'
import e2 from './E2.png'
import g2 from './G2.png'
import m2 from './M2.png'
import n2 from './N2.png'
import r2 from './R2.png'
import s2 from './S2.png'
import t2 from './T2.png'
import h2 from './H2.png'
import a2 from './A2.png'
import p2 from './P2.png'
import b2 from './B2.png'
import c2 from './C2.png'
import i2 from './I2.png'
import k2 from './K2.png'
import f2 from './F2.png'
import l2 from './L2.png'
import o2 from './O2.png'
import q2 from './Q2.png'
import u2 from './U2.png'
import v2 from './V2.png'
import w2 from './W2.png'
import x2 from './X2.png'
import y2 from './Y2.png'



export const poseImages = {
    D: d,
    E: e,
    G: g,
    M: m,
    N: n,
    R: r,
    S: s,
    T: t,
    H: h,
    A: a,
    P: p,
    B: b,
    C: c,
    F: f,
    I: i,
    K: k,
    L: l,
    O: o,
    Q: q,
    U: u,
    V: v,
    W: w,
    X: x,
    Y: y,
} 

export const poseImages_sign = {
    D: d1,
    E: e1,
    G: g1,
    M: m1,
    N: n1,
    R: r1,
    S: s1,
    T: t1,
    H: h1,
    A: a1,
    P: p1,
    B: b1,
    C: c1,
    F: f1,
    I: i1,
    K: k1,
    L: l1,
    O: o1,
    Q: q1,
    U: u1,
    V: v1,
    W: w1,
    X: x1,
    Y: y1,
    D1: d2,
    E1: e2,
    G1: g2,
    M1: m2,
    N1: n2,
    R1: r2,
    S1: s2,
    T1: t2,
    H1: h2,
    A1: a2,
    P1: p2,
    B1: b2,
    C1: c2,
    F1: f2,
    I1: i2,
    K1: k2,
    L1: l2,
    O1: o2,
    Q1: q2,
    U1: u2,
    V1: v2,
    W1: w2,
    X1: x2,
    Y1: y2,
} 

 